import { createReactRenderer } from 'helpers/react-renderer';

import FirstTimeModal from './FirstTimeModal';
import ImageUploadModal from './ImageUploadModal';

export default class ItemImportHelp {
  constructor() {
    this.bindImportModuleButton();
    this.firstTimeModal = null;
    this.imageUploadModal = null;
  }

  bindImportModuleButton() {
    $(document).on('click', '#openHelpModal', () => {
      this.initFirstTimeModal();
    });

    $(document).on('click', '#import-images-button', () => {
      this.initImageUploadModal();
      this.imageUploadModal.open();
    });
  }

  initFirstTimeModal() {
    const RenderedComponent = createReactRenderer({
      component: FirstTimeModal,
      selector: '[data-react-root="ReactModal"]',
    });

    this.firstTimeModal = RenderedComponent.mount();
  }

  initImageUploadModal() {
    const RenderedComponent = createReactRenderer({
      component: ImageUploadModal,
      selector: '[data-react-root="ReactModal"]',
      props: {
        // eslint-disable-next-line no-return-assign
        getRef: (c) => (this.imageUploadModal = c),
      },
    });

    RenderedComponent.mount();
  }
}
